import { Flex, Button, CircularProgress, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import jsPDF from "jspdf";

export function ActionButtons({
    pdf,
    isSaving,
    isLoading,
    fileName,
}: {
    pdf: jsPDF | undefined;
    isSaving: boolean;
    isLoading: boolean;
    fileName: string;
}) {
    async function handleExport() {
        if (pdf) {
            pdf.save(fileName);
        }
    }

    if (isLoading) {
        return null;
    }

    return (
        <Flex alignItems={"center"}>
            <Button
                variant="ghost-teal"
                onClick={() => window.print()}
                leftIcon={<FontAwesomeIcon icon={["far", "print"]} />}
            >
                Print
            </Button>
            {isSaving ? (
                <Flex gap={1} alignItems={"center"}>
                    <CircularProgress
                        isIndeterminate
                        color="green.300"
                        size={4}
                    />
                    <Text fontSize={"sm"}>Saving statement...</Text>
                </Flex>
            ) : (
                <Button
                    variant="ghost-teal"
                    onClick={handleExport}
                    leftIcon={<FontAwesomeIcon icon={["far", "file-pdf"]} />}
                >
                    Export
                </Button>
            )}
        </Flex>
    );
}
